import type { PassengerFormData } from '@/root/shared-types/selectTicketPage/selectTicket'
import type { Price } from '@/root/shared-types/dto/SailPricing'
import type { ReservationItem } from '@/root/shared-types/reservation/reservation-types'

export const groupQuantitiesByPriceCategory = (items: ReservationItem[]): Record<string, number> => {
  const quantities: Record<string, number> = {}

  for (const item of items) {
    quantities[item.priceCategory] = (quantities[item.priceCategory] ?? 0) + item.quantity
  }

  return quantities
}

export const getResidentBucketCode = (prices: Price[] | undefined): string | undefined =>
  prices?.find((price) => price.priceCategory.isResident)?.priceCategory.code

export const getResidentSubCategoryCodes = (items: ReservationItem[]): Set<string> =>
  new Set(
    items
      .filter((item) => item.resident && item.priceCategorySubType === 'DECK')
      .map((item) => item.priceCategory)
  )

export const aggregateResidentQuantities = (
  initialQuantityByCode: Record<string, number>,
  residentSubCategoryCodes: Set<string>,
  residentBucketCode: string | undefined
): Record<string, number> => {
  if (!residentBucketCode) return initialQuantityByCode
  const result: Record<string, number> = {}
  let residentSum = 0
  for (const [code, qty] of Object.entries(initialQuantityByCode)) {
    if (residentSubCategoryCodes.has(code)) {
      residentSum += qty
    } else {
      result[code] = qty
    }
  }
  if (residentSum > 0) result[residentBucketCode] = residentSum
  return result
}

export const aggregateResidentPassengers = (
  initialPassengersByCode: Record<string, PassengerFormData[]>,
  residentSubCategoryCodes: Set<string>,
  residentBucketCode: string | undefined
): Record<string, PassengerFormData[]> => {
  if (!residentBucketCode) return initialPassengersByCode
  const result: Record<string, PassengerFormData[]> = {}
  const residentBucket: PassengerFormData[] = []
  for (const [code, passengers] of Object.entries(initialPassengersByCode)) {
    if (residentSubCategoryCodes.has(code)) {
      residentBucket.push(...passengers)
    } else {
      result[code] = passengers
    }
  }
  if (residentBucket.length > 0) result[residentBucketCode] = residentBucket
  return result
}
